import { SB } from '@play-co/replicant';

export const minigameSchema = {
  minigame: SB.object({
    minigameCount: SB.number().min(0).default(0),
    minigameShown: SB.boolean().default(false),
  }),
};
